import { ApiService } from "./api.service";

export const MenuService = {
    categoryGet: category_code => ApiService.get(`/menu/category/${category_code}`),
    categoryGetOrCreate: category_code => ApiService.post(`/menu/category/`, {category_code}),
    categoryGetAll: () => ApiService.get(`/menu/categories/`),
    categoryUpdate: data => ApiService.put(`/menu/category/`, data),
    categoryDelete: id => ApiService.delete(`/menu/category/${id}`),
    // 

    categoryProductGet: category_code => ApiService.get(`/menu/category/products/${category_code}`),
    postProduct: data => ApiService.post(`/menu/category/product/`, data),
    deleteProduct: id => ApiService.delete(`/menu/category/product/${id}`),
}




// WEBPACK FOOTER //
// ./src/services/menu.service.js